export default __webpack_public_path__ + "static/media/movies.29d37f1c.png";